"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _nextUtil = require("@alicd/next-util");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CNTableScrollOverlay = function (_React$Component) {
    (0, _inherits3.default)(CNTableScrollOverlay, _React$Component);

    function CNTableScrollOverlay(props) {
        (0, _classCallCheck3.default)(this, CNTableScrollOverlay);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CNTableScrollOverlay.__proto__ || (0, _getPrototypeOf2.default)(CNTableScrollOverlay)).call(this, props));

        _this.state = {
            scrollbarSize: 24
        };
        _this.handleScroll = _this.handleScroll.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(CNTableScrollOverlay, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.setState({ layoutScrollbarSize: (0, _nextUtil.scrollbar)().height });
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            var wrap = _reactDom2.default.findDOMNode(this.refs.wrap);
            if (wrap) {
                var currScroll = wrap.scrollLeft;
                if (currScroll != this.props.value) {
                    wrap.scrollLeft = this.props.value;
                }
            }
        }
    }, {
        key: "handleScroll",
        value: function handleScroll() {
            var wrap = _reactDom2.default.findDOMNode(this.refs.wrap);
            var currScroll = wrap.scrollLeft;
            this.props.onScroll && this.props.onScroll.call(this, currScroll);
        }
    }, {
        key: "updateScroll",
        value: function updateScroll(value) {
            var wrap = _reactDom2.default.findDOMNode(this.refs.wrap);
            wrap && (wrap.scrollLeft = value);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                clientWidth = _props.clientWidth,
                scrollWidth = _props.scrollWidth,
                style = _props.style,
                className = _props.className;
            var scrollbarSize = this.state.scrollbarSize;


            if (clientWidth >= scrollWidth) {
                return null;
            }

            var styleOuter = {
                width: clientWidth + "px"
            };
            var styleWrap = {
                width: clientWidth + "px",
                height: scrollbarSize + "px"
            };
            var styleInner = {
                width: scrollWidth + "px"
            };

            return _react2.default.createElement(
                "div",
                {
                    ref: "outer",
                    className: (0, _classnames2.default)("scroll-overlay-outer", className),
                    style: (0, _assign2.default)(styleOuter, style)
                },
                _react2.default.createElement(
                    "div",
                    {
                        ref: "wrap",
                        className: "scroll-overlay",
                        style: styleWrap,
                        onScroll: this.handleScroll
                    },
                    _react2.default.createElement("div", { className: "scroll-overlay-inner", style: styleInner })
                )
            );
        }
    }]);
    return CNTableScrollOverlay;
}(_react2.default.Component);

CNTableScrollOverlay.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    clientWidth: _propTypes2.default.number,
    scrollWidth: _propTypes2.default.number,
    value: _propTypes2.default.number,
    onScroll: _propTypes2.default.func
};
CNTableScrollOverlay.defaultProps = {
    clientWidth: 0,
    scrollWidth: 0,
    value: 0
};
exports.default = CNTableScrollOverlay;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/CNTableScrollOverlay.js
// module id = 677
// module chunks = 0